import { useState } from "react";
import { Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { compareByName } from "../../Utilities/sortHelper";
import { linkModulesToCourses } from "../../Utilities/linkModulesToCourses";
import SearchableCheckList from "../Inputs/SearchableCheckList";
import ModuleTypeIcon from "../Module/ModuleTypeIcon";

export default function AddModuleToCourseForm({
  modules,
  courseId,
  reloadModules,
  dismissModal,
}) {
  const intl = useIntl();
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const sortedModules = [...modules].sort(compareByName);

  const items = sortedModules.map((module) => ({
    id: module.id,
    label: module.name,
    sublabel: module.url?.includes("Scormfiles/")
      ? module.url.split("Scormfiles/")[1]
      : (module.url ?? ""),
    icon: <ModuleTypeIcon moduleType={module.moduleType} />,
  }));

  const handleSave = async () => {
    setIsSaving(true);

    const links = sortedModules
      .filter((module) => selectedModuleIds.includes(module.id))
      .map((module) => ({
        courseId: courseId,
        moduleId: module.id,
        label: module.name,
      }));

    await linkModulesToCourses(
      links,
      intl,
      "ModulesAddedToCourse",
      "SomeModulesCouldNotBeAdded",
    );

    setIsSaving(false);
    reloadModules();
    dismissModal();
  };

  return (
    <div className="col-12 col-sm-12">
      <SearchableCheckList
        items={items}
        selectedIds={selectedModuleIds}
        onChange={setSelectedModuleIds}
        searchPlaceholder={intl.formatMessage({ id: "SearchModuleOrFileName" })}
      />
      <div className="d-flex align-items-center mt-3">
        <span className="text-muted">
          <FormattedMessage
            id="ModulesSelected"
            values={{ count: selectedModuleIds.length }}
          />
        </span>
        <Button
          outline
          color="secondary"
          className="ms-auto me-2"
          onClick={() => dismissModal()}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          outline
          color="primary"
          onClick={handleSave}
          disabled={isSaving || selectedModuleIds.length === 0}
        >
          <FormattedMessage id={isSaving ? "Wait" : "Save"} />
        </Button>
      </div>
    </div>
  );
}
